import axios from 'axios';

// Resolve backend URL: when running on a custom domain (e.g. crm.gruposach502.com)
// the .env REACT_APP_BACKEND_URL may point to the managed Emergent host, which
// causes cross-origin CORS issues. In production-like custom domains we use the
// same origin where the frontend is served so all /api calls stay same-origin.
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const resolveBackendUrl = () => {
  if (typeof window === 'undefined' || !window.location) return ENV_BACKEND_URL;
  const host = window.location.hostname;
  // Use same-origin for any deployed custom/production domain (anything that is NOT a preview/managed Emergent host)
  const isManagedEmergent = /\.preview\.emergentagent\.com$|\.emergent\.host$|^localhost$|^127\./.test(host);
  if (!isManagedEmergent) {
    return `${window.location.protocol}//${window.location.host}`;
  }
  return ENV_BACKEND_URL;
};
const BACKEND_URL = resolveBackendUrl();

// Create axios instance with credentials
const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Renovación automática de sesión: ante un 401 intenta /auth/refresh UNA vez
// (cola compartida para peticiones concurrentes) y reintenta la petición original.
// Si la renovación falla, avisa a la app para mostrar el re-login sin perder datos.
let refreshPromise = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || '';
    const esAuth = /\/auth\/(login|refresh|logout|register)/.test(url);
    if (status === 401 && !original._retry && !esAuth) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post('/auth/refresh').finally(() => { refreshPromise = null; });
        }
        await refreshPromise;
        return api(original);
      } catch (e) {
        window.dispatchEvent(new CustomEvent('sach:session-expired'));
      }
    }
    return Promise.reject(error);
  }
);

// Helper to format API errors
export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Algo salió mal. Intenta de nuevo.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

export default api;
